import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import {
  SurveyTemplateDTO,
  CreateSurveyTemplateDTO,
  UpdateSurveyTemplateDTO,
  SurveyTemplateListDTO,
} from '../dtos';

export const surveyTemplateApi = {
  // Create survey template
  createTemplate: async (
    tenantId: string,
    data: CreateSurveyTemplateDTO
  ): Promise<ApiResponse<SurveyTemplateDTO>> => {
    return apiClient.post(`/tenants/${tenantId}/survey-templates`, data);
  },

  // Get survey template by ID
  getTemplate: async (
    tenantId: string,
    templateId: string
  ): Promise<ApiResponse<SurveyTemplateDTO>> => {
    return apiClient.get(`/tenants/${tenantId}/survey-templates/${templateId}`);
  },

  // Get all survey templates for tenant
  getTemplatesByTenant: async (tenantId: string): Promise<ApiResponse<SurveyTemplateListDTO>> => {
    return apiClient.get(`/tenants/${tenantId}/survey-templates`);
  },

  // Update survey template
  updateTemplate: async (
    tenantId: string,
    templateId: string,
    data: UpdateSurveyTemplateDTO
  ): Promise<ApiResponse<SurveyTemplateDTO>> => {
    return apiClient.put(`/tenants/${tenantId}/survey-templates/${templateId}`, data);
  },

  // Delete survey template
  deleteTemplate: async (tenantId: string, templateId: string): Promise<ApiResponse<void>> => {
    return apiClient.delete(`/tenants/${tenantId}/survey-templates/${templateId}`);
  },
};
